import {Component, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {MatSlideToggle} from '@angular/material/slide-toggle';
import {partnerNameByCurrentPartnerIdSelector} from '../../partner/partner.reducer';
import {selectUserIsAdmin} from '../../user/user.reducer';
import {Segment} from '../segment.model';
import {SubSink} from 'subsink';
import {BehaviorSubject, Observable} from 'rxjs';
import {Store} from '@ngrx/store';

@Component({
  selector: 'app-segment-global-toggle',
  styleUrls: ['global-toggle.component.scss'],
  template: `
    <div class="form-group" *ngIf="isAdmin$ | async">
      <mat-slide-toggle #globalSegmentToggle
                        name="global"
                        id="global-toggle"
                        data-cy="toggle-segment-global"
                        [disabled]="disabled$ | async"
                        [checked]="isChecked()">
        <strong id="current-customer" [ngClass]="{'inactive': disabled$ | async}">Global</strong>
      </mat-slide-toggle>
      <p data-name="current-customer" *ngIf="!globalSegmentToggle.checked">Partners: {{currentPartnerName$ | async}}</p>
      <p *ngIf="globalSegmentToggle.checked">All Partners</p>
    </div>`
})
export class SegmentGlobalToggleComponent implements OnDestroy, OnInit {
  @ViewChild('globalSegmentToggle') toggle!: MatSlideToggle;
  @Input() newSegment!: boolean;
  isAdmin$: Observable<boolean> = this.store.select(selectUserIsAdmin);
  currentPartnerName$: Observable<string | undefined> = this.store.select(partnerNameByCurrentPartnerIdSelector);
  disabled$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  subsink = new SubSink();

  constructor(private store: Store) {
  }

  private _segment!: Segment;

  @Input() set segment(value: Segment) {
    this._segment = value;
    if (this._segment) {
      this.enabledIfPrivateOrGlobalWithoutShares();
    } else {
      this.disabled$.next(false);
    }
  }


  ngOnDestroy() {
    this.subsink.unsubscribe();
  }

  isChecked(): boolean {
    if (this.newSegment) {
      return false;
    }
    return this._segment ? !this._segment.partnerId : false;
  }

  ngOnInit(): void {
    if (!this._segment) {
      this.disabled$.next(false);
    }
  }

  private enabledIfPrivateOrGlobalWithoutShares() {
    if (this.isSegmentPrivate() || !this.segmentIsGlobalAndHasShares()) {
      this.disabled$.next(false);
    } else {
      this.disabled$.next(true);
    }
  }

  private segmentIsGlobalAndHasShares() {
    return !this._segment.partnerId && this._segment.sharedAccounts?.length > 0;
  }

  private isSegmentPrivate() {
    return this._segment.partnerId !== undefined && this._segment.partnerId > 0;
  }
}
